/* @ngInject */
export default function ($rootScope, $location, $route, AuthService) {
    const deregister = $rootScope.$on('$routeChangeStart', (event, next) => {
        const publicRoute = next.public !== undefined ? next.public : false;

        if (!publicRoute && AuthService.hasCredentials() === false) {
            event.preventDefault();
            AuthService.refreshCredentials()
                .then(() => {
                    // trigger reload with fresh credentials
                    $route.reload();
                })
                .catch(() => {
                    const currentUrl = $location.url();

                    if ((currentUrl !== undefined) &&
                        (currentUrl.length > 0) &&
                        (!currentUrl.startsWith('/login'))) {
                        $location.url(`/login?next=${currentUrl}`);
                    } else {
                        $location.url('/login');
                    }
                });
        }
    });

    $rootScope.$on('$destroy', deregister);
}



// WEBPACK FOOTER //
// ./src/app/config/auth.js